import {TotalService} from './total.service';

export const TotalInjectables: Array<any> = [
  {
    provide: TotalService,
    useClass: TotalService,
  },
];
